import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getErrorMessage } from '../utils/errorHandler';
import toast from 'react-hot-toast';
import { HiOutlineMail, HiOutlineLockClosed } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { systemAPI, settingsAPI } from '../services/api';
import { IOSButton } from '../components/ios';
import PWAInstallPrompt from '../components/PWAInstallPrompt';

function MobileLogin() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const [version, setVersion] = useState('');
  const [registrationEnabled, setRegistrationEnabled] = useState(true);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await systemAPI.getVersion();
        setVersion(response.data.version);
      } catch (error) {
        setVersion('1.4.1');
      }
    };

    const fetchRegistrationStatus = async () => {
      try {
        const response = await settingsAPI.getRegistrationStatus();
        setRegistrationEnabled(response.data.enabled);
      } catch (error) {
        setRegistrationEnabled(true);
      }
    };

    fetchVersion();
    fetchRegistrationStatus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error(t('auth.fillAllFields'));
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      toast.success(t('auth.loginSuccess'));
      navigate('/dashboard');
    } catch (error) {
      const errorDetail = error.response?.data?.detail;
      
      if (errorDetail === 'Invalid email or password' || 
          errorDetail === 'Email ou senha incorretos') {
        toast.error(t('errors.invalidCredentials'));
      } else {
        const errorMessage = getErrorMessage(error);
        toast.error(errorMessage);
      }
      
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mobile-auth-page">
      {/* Header com logo */}
      <div className="mobile-auth-header">
        <h1>My Series</h1>
        <p>Movies & Series Tracker</p>
      </div>

      {/* Formulário */}
      <form className="mobile-auth-form" onSubmit={handleSubmit}>
        <div className="mobile-auth-field">
          <label>{t('common.email')}</label>
          <div className="mobile-auth-input-wrapper">
            <HiOutlineMail className="mobile-auth-icon" />
            <input
              type="email"
              placeholder={t('profile.enterEmail')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              autoFocus
            />
          </div>
        </div>

        <div className="mobile-auth-field">
          <label>{t('common.password')}</label>
          <div className="mobile-auth-input-wrapper">
            <HiOutlineLockClosed className="mobile-auth-icon" />
            <input
              type="password"
              placeholder={t('common.password')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>
        </div>

        <IOSButton
          type="submit"
          variant="primary"
          fullWidth
          disabled={loading}
          className="mobile-auth-submit"
        >
          {loading ? t('auth.loggingIn') : t('auth.login')}
        </IOSButton>

        <Link to="/forgot-password" className="mobile-auth-link">
          {t('auth.forgotPassword')}
        </Link>

        {registrationEnabled && (
          <div className="mobile-auth-footer">
            <span>{t('auth.dontHaveAccount')}</span>
            <Link to="/register" className="mobile-auth-link-primary">
              {t('auth.createAccount')}
            </Link>
          </div>
        )}
      </form>

      {/* Versão */}
      <div className="mobile-auth-version">
        <p>{t('auth.copyright')}</p>
        <p>{t('common.version')} {version}</p>
      </div>

      {/* PWA Install Prompt */}
      <PWAInstallPrompt />
    </div>
  );
}

export default MobileLogin;
